import Link from "next/link";
import { twMerge } from "tailwind-merge";

export function TextLink({
  children,
  href,
  external,
  className,
}: {
  children: React.ReactNode;
  href: string;
  external: boolean;
  className?: string;
}) {
  if (external) {
    return (
      <a
        href={href}
        className={twMerge(
          "text-sm font-semibold leading-6 text-gray-900 transition-colors hover:text-gray-600",
          className
        )}
        target="_blank"
      >
        {children}
      </a>
    );
  } else {
    return (
      <Link
        href={href}
        className={twMerge(
          "text-sm font-semibold leading-6 text-gray-900 transition-colors hover:text-gray-600",
          className
        )}
      >
        {children}
      </Link>
    );
  }
}
